module.exports = __webpack_public_path__ + "static/media/japanese_team.d22eae92.svg";